import * as React from "react";
import { useProfiles } from "./useProfiles";

export const useProfile = (id: string) => {
  const profiles = useProfiles();
  return React.useMemo(() => {
    return profiles.find((profile) => profile.id === Number(id));
  }, [id, profiles]);
};
